export const EXPERIMENTS = {
  MARKETING_CONSENT_WITH_PERMISSION: 'specs.ping.MAPreferences.MarketingConsentWithPermission',
  ERROR_HANDLER_IN_UOU: 'specs.ping.errorHandlerInUou',
  USE_MA_WIDGET_PLUGIN_SERVICE: 'specs.ping.MAPreferences.useMAWidgetPluginService',
};
